/**
 * ai.summarize - produce a short summary and stripped context
 * Input: context object or string
 * Output: { summary: string, context: object }
 */
module.exports = function summarize(context) {
  try {
    if (!context) return { summary: '', context: {} }
    const text = typeof context === 'string' ? context : JSON.stringify(context)
    const summary = text.slice(0, 300) + (text.length > 300 ? '...' : '')
    // attempt to keep only essential keys if object
    let stripped = {}
    if (typeof context === 'object') {
      const keys = Object.keys(context).slice(0, 10)
      keys.forEach(k => { stripped[k] = context[k] })
    }
    return { summary, context: stripped }
  } catch (e) {
    return { summary: '', context: {} }
  }
}
